import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router'
import ArticlesList from './articles-list'
import SubCategoriesList from './sub-categories-list'
import PropTypes from 'prop-types'
import routingObject from '../../../utils/static-routes'
import {useCategoryMeta} from '../../../hooks/use-category-meta'
import {Helmet} from 'react-helmet'

const CategoriesRouter = ({
    selectedCategory,
    setGoBackText,
    setGoBackToPath,
    setPageTitle,
    listOfCategories,
    setIsLoading,
}) => {
    const {category_id} = useParams()
    const [categoryType, setCategoryType] = useState('')

    const {metaTitle, metaDescription} = useCategoryMeta()

    const currentCategory = selectedCategory || listOfCategories?.data?.[category_id]

    useEffect(() => {
        if (currentCategory?.topics && Object.keys(currentCategory.topics).length > 0) {
            setPageTitle(currentCategory?.category_name || 'default')
            setGoBackText('default')
            setGoBackToPath(routingObject.FAQ_PATH)
            setCategoryType('subcategories')
        } else {
            setCategoryType('articles')
        }
    }, [currentCategory])

    if (categoryType === 'subcategories') {
        return (
            <>
                <Helmet>
                    {metaTitle && <title>{metaTitle}</title>}
                    {metaDescription && <meta name="description" content={metaDescription} />}
                </Helmet>
                <SubCategoriesList
                    selectedCategory={currentCategory}
                    setGoBackText={setGoBackText}
                    setGoBackToPath={setGoBackToPath}
                    listOfCategories={listOfCategories}
                />
            </>
        )
    } else if (categoryType === 'articles') {
        return (
            <ArticlesList
                setGoBackText={setGoBackText}
                setGoBackToPath={setGoBackToPath}
                setPageTitle={setPageTitle}
                listOfCategories={listOfCategories}
                setIsLoading={setIsLoading}
            />
        )
    }
}

export default CategoriesRouter

CategoriesRouter.propTypes = {
    setGoBackText: PropTypes.func,
    setGoBackToPath: PropTypes.func,
    setHasSubcategory: PropTypes.func,
    selectedCategory: PropTypes.object,
    setPageTitle: PropTypes.func,
    listOfCategories: PropTypes.object,
    setIsLoading: PropTypes.func,
}
